import { findOrphanedSession } from "./assemblyAIRecovery";
import { findOrphanedRecording } from "./recordingPersistence";

/**
 * Whether this case still has a saved recording that was never sent — an
 * interrupted one, or a stopped one whose upload failed (MDRS-551). A new
 * recording on the case deletes it, so Start Session checks this first.
 * Checks both engines' stores: orphans survive a flag flip.
 */
export const hasUnsentRecording = async (caseNumber: string): Promise<boolean> => {
  const [recording, session] = await Promise.all([
    findOrphanedRecording(caseNumber).catch(() => null),
    findOrphanedSession(caseNumber).catch(() => null),
  ]);
  return !!recording || !!session;
};
